import { Building2, Shield, Check, Award, Truck, Factory } from 'lucide-react';

const VALUE_PROPS = [
  { icon: Award, title: '10+ Years Legacy', desc: 'Manufacturing expertise since 2014' },
  { icon: Factory, title: 'Factory Direct', desc: 'No middlemen, best prices guaranteed' },
  { icon: Truck, title: 'Pan-India Delivery', desc: 'Free delivery in Mumbai & Navi Mumbai' },
  { icon: Shield, title: 'Made in India', desc: 'Premium quality, proudly Indian' }
];

const WHY_CHOOSE_US = [
  { title: '100% Freestanding', desc: 'Looks built-in but isn\'t bolted down. Complete flexibility for future changes.', icon: Building2 },
  { title: 'Asset, Not Expense', desc: 'Take it with you when you move. Modular furniture retains value.', icon: Shield },
  { title: 'Zero Renovation Mess', desc: 'No sawdust, no delays. Arrives pre-assembled, installs in hours.', icon: Check },
  { title: 'Kholo, Jodo, Lagalo', desc: 'Tool-free assembly. Open it, Join it, Set it up. That simple.', icon: Award }
];

export function ValuePropositionsCompact() {
  return (
    <section className="py-16">
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {VALUE_PROPS.map((item, i) => (
            <div key={i} className="flex flex-col items-center text-center p-6 bg-white border border-gray-200 hover:border-[#c5a059] transition-colors group">
              <div className="w-14 h-14 bg-[#c5a059]/10 flex items-center justify-center mb-4 group-hover:bg-[#c5a059]/20 transition-colors">
                <item.icon className="w-7 h-7 text-[#c5a059]" />
              </div>
              <h3 className="font-bold text-[#1a1a1a] mb-1">{item.title}</h3>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function WhyChooseUs() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-[#c5a059] text-sm tracking-[0.3em] uppercase mb-4 font-medium">
            The MFS Advantage
          </p>
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#1a1a1a]"
            
          >
            Why Corporate India Trusts Us
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {WHY_CHOOSE_US.map((item, i) => (
            <div key={i} className="flex gap-6 p-8 bg-[#f5f3ef] border border-gray-200 hover:border-[#c5a059] hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-[#c5a059]/10 flex items-center justify-center flex-shrink-0">
                <item.icon className="w-7 h-7 text-[#c5a059]" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-2">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
